(() => {
  const init = () => {
    document.querySelectorAll('[data-vl-closeout]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const links = root.querySelectorAll('[data-vl-price]');
      const sync = () => {
        const current = new URL(location.href);
        links.forEach(link => {
          const value = link.dataset.vlPrice;
          const url = new URL(current);
          ['filter.v.price.gte','filter.v.price.lte','page'].forEach(key => url.searchParams.delete(key));
          if (value) url.searchParams.set('filter.v.price.lte', value);
          url.hash = 'CollectionProductGrid';
          link.href = url.href;
          const active = value && current.searchParams.get('filter.v.price.lte') === value && !Number(current.searchParams.get('filter.v.price.gte'));
          if (active) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
        });
      };
      sync();
      root.addEventListener('pointerdown',sync);
      root.addEventListener('focusin',sync);
      window.addEventListener('popstate',sync);
      const grid = document.getElementById('CollectionProductGrid');
      if (grid) new MutationObserver(sync).observe(grid,{childList:true,subtree:true});
    });
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();
